import React, { useState, useEffect } from 'react';
import { getData } from '../../utils/data';

export const GlobalContext = React.createContext({
  country: null,
  setCountry: () => {},
  sector: null,
  setSector: () => {},
  activePathway: null,
  setActivePathway: () => {},
  data: null,
  setData: () => {},
  countries: null,
  setCountries: () => {},
  pathways: null,
  setPathways: () => {},
});

const GlobalContextProvider = ({ children }) => {
  const [data, setData] = useState(null);
  const [countries, setCountries] = useState(null);
  const [country, setCountry] = useState(null);
  const [sector, setSector] = useState(null);
  const [activePathway, setActivePathway] = useState(null);
  const [pathways, setPathways] = useState(null);
  const [sectors, setSectors] = useState(null);

  useEffect(() => {
    async function fetchData(){
      const data = await getData();
      setData(data)
      if (data.countries) {
        setCountries(data.countries);
      }
    }

    fetchData()
  }, [])

  useEffect(() => {
    if (data) {
      if (country) {
        const filteredPathways = data?.pathways.filter((pathway) => {
          return pathway.origin.some(origin => origin.value === country) ||  pathway.destination.some(destination => destination.value === country)
        });
        setPathways(filteredPathways);
        setSectors(data.sectorsByCountry[country])
        setSector(null);
        setActivePathway(null);
      } else {
        setPathways(null);
      }
    }
  }, [
    country,
    data,
  ]);

  useEffect(() => {
    if (sector) {
      const filteredPathways = data?.pathways.filter((pathway) => {
        return (pathway.origin.some(origin => origin.value === country) ||  pathway.destination.some(destination => destination.value === country)) && pathway.skillType.some(skill => skill === sector)
      });

      setPathways(filteredPathways);
    } else {
      const filteredPathways = data?.pathways.filter((pathway) => {
        return pathway.origin.some(origin => origin.value === country) ||  pathway.destination.some(destination => destination.value === country)
      });
      setPathways(filteredPathways);
    }
  }, [sector])

  return (
    <GlobalContext.Provider
      value={{
        country,
        setCountry,
        sector,
        setSector,
        activePathway,
        setActivePathway,
        data,
        countries,
        pathways,
        sectors,
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};

export default GlobalContextProvider;
